import React from "react";
import createSvgIcon from "./createSvgIcon";

export default createSvgIcon(
  <path d="M26.33,14.71A11.63,11.63,0,1,1,14.71,3.08,11.62,11.62,0,0,1,26.33,14.71Zm-4.76,5.8A5.21,5.21,0,0,0,17,17.71a1,1,0,0,0-.34.05,6.32,6.32,0,0,1-1.91.32,6.44,6.44,0,0,1-1.92-.32,1,1,0,0,0-.33-.05,5.23,5.23,0,0,0-4.62,2.8,9,9,0,0,0,13.73,0Zm-11-8.8a4.13,4.13,0,1,0,4.13-4.13A4.13,4.13,0,0,0,10.58,11.71Z" />,
  "PeopleSearch",
  "0 0 29.41 29.41"
);
